import {componentConfig, componentLoader} from "../../lib/component_initializer";
import {ImageMetadata, ImageMetadataConfig} from "./image_metadata";

export const imageMetadataLoader = function (options = {}) {
    componentLoader(componentConfig(ImageMetadata, ImageMetadataConfig.componentTypeKey, ImageMetadataConfig.baseHtmlClass), options);
};
